/* eslint-disable no-unused-vars */
import { createAction } from '@reduxjs/toolkit';
import eventProvider from '../../event/eventProvider';
import { VehicleUseCaseType } from '../type';
enum ActionType {
  KEEP_ALIVE = 'KEEP_ALIVE',
  SEND_HTTP_REQUEST = 'SEND_HTTP_REQUEST',
  SEND_SOCKET_DATA = 'SEND_SOCKET_DATA',
  CONNECTION_OK = 'CONNECTION_OK',
  CONNECTION_LOST = 'CONNECTION_LOST',
  CLEAR_COMMON_STATE = 'CLEAR_COMMON_STATE',
  CHANGE_FETCH_TYPE = 'CHANGE_FETCH_TYPE',
  BASIC_INFO = 'BASIC_INFO',
  VEHICLE_DRIVABLE_DIRECTION = 'VEHICLE_DRIVABLE_DIRECTION',
  REALTIME_INIT_INFO = 'REALTIME_INIT_INFO',
  REALTIME_DETAIL_INFO = 'REALTIME_DETAIL_INFO',
  REALTIME_GLOBAL_INFO = 'REALTIME_GLOBAL_INFO',
  SET_SELECTED_VEHICLE_USE_CASE_TYPE = 'SET_SELECTED_VEHICLE_USE_CASE_TYPE',
  TOKEN_INVALID = 'TOKEN_INVALID',
  CLEAR_REALTIME_BOARD_DATA = 'CLEAR_REALTIME_BOARD_DATA',
  FILTER_VEHICLE_BY_TYPE = 'FILTER_VEHICLE_BY_TYPE',
  ISSUE_ALARM_AND_OPERATION_LIST = 'ISSUE_ALARM_AND_OPERATION_LIST',
  USER_METADATA_VEHICLE = 'USER_METADA_VEHICLE',
  USER_METADATA_CITY = 'USER_METADA_CITY',
  ALL_ALARM_EVENT = 'ALL_ALARM_EVENT',
  MULTI_VEHICLE = 'MULTI_VEHICLE',
  CLEAR_ISSUE_ALARM_AND_OPERATION_LIST = 'CLEAR_ISSUE_ALARM_AND_OPERATION_LIST',
  GET_ENUM_LIST_MAP = 'GET_ENUM_LIST_MAP',
  CHANGE_ALARM_EVENT = 'CHANGE_ALARM_EVENT',
  MAP_VEHICLE_POSITION_REQUEST = 'MAP_VEHICLE_POSITION_REQUEST',
  CHANGE_CONNECT = 'CHANGE_CONNECT',
  MAP_VEHICLE_SCHEDULE_REQUEST = 'MAP_VEHICLE_SCHEDULE_REQUEST',
  MAP_VEHICLE_SCHEDULE_UPDATE = 'MAP_VEHICLE_SCHEDULE_UPDATE',
  MAP_VEHICLE_SCHEDULE_CANCEL_REQUEST = 'MAP_VEHICLE_SCHEDULE_CANCEL_REQUEST',
  FORMAT_ALARM_EVENT_TO_MENU = 'FORMAT_ALARM_EVENT_TO_MENU',
  ISSUE_SUBSCRIBE_REQUEST = 'ISSUE_SUBSCRIBE_REQUEST',
  ISSUE_UPDATE_EVENT = 'ISSUE_UPDATE_EVENT',
  COMMON_MESSAGE = 'COMMON_MESSAGE',
  VEHICLE_START_UP = 'VEHICLE_START_UP',
  UPDATE_COMMON_VEHICLE = 'UPDATE_COMMON_VEHICLE',
  UPDATE_COMMON_STATION = 'UPDATE_COMMON_STATION',
  UPDATE_COMMON_CITY = 'UPDATE_COMMON_CITY',
}
export const actionSendSocketData = createAction<any | undefined>(
  ActionType.SEND_SOCKET_DATA,
);

export const actionSendHttpRequest = createAction<any | undefined>(
  ActionType.SEND_HTTP_REQUEST,
);

export const actionConnectionOk = createAction(ActionType.CONNECTION_OK);
export const actionConnectionLost = createAction(ActionType.CONNECTION_LOST);
export const actionClearCommonState = createAction(
  ActionType.CLEAR_COMMON_STATE,
);
export const actionChangeFetchType = createAction<any>(
  ActionType.CHANGE_FETCH_TYPE,
);
export const actionFetchBasicInfo = createAction<any>(
  eventProvider.makeResponseType(ActionType.BASIC_INFO),
);
export const actionFetchVehicleEnable = createAction<any>(
  eventProvider.makeResponseType(ActionType.VEHICLE_DRIVABLE_DIRECTION),
);
export const actionFetchInitInfo = createAction<any>(
  eventProvider.makeResponseType(ActionType.REALTIME_INIT_INFO),
);

export const actionFetchRealtimeDetailInfo = createAction<any>(
  eventProvider.makeResponseType(ActionType.REALTIME_DETAIL_INFO),
);

export const actionFetchRealtimeGlobalInfo = createAction<any>(
  eventProvider.makeResponseType(ActionType.REALTIME_GLOBAL_INFO),
);

export const actionSetSelectVehicleUseCaseType = createAction<
  VehicleUseCaseType | undefined
>(ActionType.SET_SELECTED_VEHICLE_USE_CASE_TYPE);

export const actionTokenInValid = createAction(
  eventProvider.makeResponseType(ActionType.TOKEN_INVALID),
);

export const actionChangeFilterType = createAction<string>(
  ActionType.FILTER_VEHICLE_BY_TYPE,
);

export const actionAlarmDetailInfo = createAction<string>(
  eventProvider.makeResponseType(ActionType.ISSUE_ALARM_AND_OPERATION_LIST),
);
export const actionClearAlarmDetailInfo = createAction<string>(
  eventProvider.makeResponseType(
    ActionType.CLEAR_ISSUE_ALARM_AND_OPERATION_LIST,
  ),
);

export const actionMergeAlarmToMenu = createAction(
  eventProvider.makeResponseType(ActionType.FORMAT_ALARM_EVENT_TO_MENU),
);

export const actionMultiVehicle = createAction<any>(
  ActionType.UPDATE_COMMON_VEHICLE,
);

export const actionMultiStation = createAction<any>(
  ActionType.UPDATE_COMMON_STATION,
);

export const actionMultiCity = createAction<any>(ActionType.UPDATE_COMMON_CITY);

export default ActionType;
